import { useEffect, useRef } from "react";
import { DCUICaptureStepTypes } from "@enums/dcui-capture-step-types";
import { DCUIContent } from "@iddataweb/idw-common-ui/types";
import {
    getCaptureStepScreenOrientationMediaUrl,
    getCaptureStepScreenOrientationPreviewMessage,
    getCaptureStepShowScreenOrientationPreview
} from "@utils/dcui-capture-step-util";
import styles from "./dcui-theming-orientation-preview-container.less";

type DCUIThemingOrientationPreviewContainerProps = {
    stepType: DCUICaptureStepTypes;
    dcuiContent: DCUIContent
};

export const DCUIThemingOrientationPreviewContainer = (props: DCUIThemingOrientationPreviewContainerProps) => {
    const { stepType, dcuiContent } = props;

    const videoRef = useRef<HTMLVideoElement>(null);

    const showScreenOrientationPreview = getCaptureStepShowScreenOrientationPreview(stepType, dcuiContent);
    const orientationPreviewMessage = getCaptureStepScreenOrientationPreviewMessage(stepType, dcuiContent);
    const screenOrientationMediaUrl = getCaptureStepScreenOrientationMediaUrl(stepType, dcuiContent);

    useEffect(() => {
        if (videoRef?.current) {
            videoRef.current.load();
        }
    }, [screenOrientationMediaUrl])

    return (
        <div className={styles.dcuiThemingOrientationPreviewContainer}>
            {showScreenOrientationPreview && orientationPreviewMessage && orientationPreviewMessage !== "." && (
                <span className={styles.previewMessage}>{orientationPreviewMessage}</span>
            )}
            <div className={styles.media}>
                {screenOrientationMediaUrl.includes(".mp4") ? (
                    <video ref={videoRef} playsInline={true} autoPlay={true} muted={true} loop={true}>
                        <source src={screenOrientationMediaUrl} />
                    </video>
                ) : (
                    <img src={screenOrientationMediaUrl} />
                )}
            </div>
        </div>
    );
};